import React from 'react';
import PropTypes from 'prop-types';

import Popup from '../../Popup';
import { capitalize } from '../../../utils/formatting';

import styles from './awaitApiSuccessPopup.scss';

const AwaitApiSuccessPopup = props => {
    const {
        onCloseClick,
        onCtaClick,
        confirmationTitle = 'Confirmation',
        confirmationMessage = 'Are you sure?',
        confirmationDataValue,
        confirmButtonLabel = 'Yes',
        successMessage,
        isSending,
        isSuccess,
        isError,
    } = props;

    let confirmLabelDisplay = confirmButtonLabel;
    if (isSuccess || isError) {
        confirmLabelDisplay = 'OK';
    }

    let messageDisplay = confirmationMessage;
    if (isSuccess) {
        messageDisplay = successMessage || 'Your request processed successfully.';
    } else if (isError) {
        messageDisplay = 'Error processing your request.';
    }

    return (
        <Popup
            className={`popup-sm`}
            popUpClassName={`${styles.awaitApiSuccessPopup}`}
            onCloseClick={onCloseClick}
            config={{
                noPadding: true,
                fullScreen: false,
                topGradient: false,
                scrollable: false,
                noHeader: true,
                showCloseIcon: false,
            }}
        >
            <div className={`${styles.section} pt24`}>
                <div className={`${styles.title} text-dark`} data-testid="await-api-success-popup.title">
                    {capitalize(confirmationTitle)}
                </div>
            </div>
            <div className={` ${styles.confirmationMessage} ${styles.section} pt0`}>
                <div className="row">
                    <div className="col-12">
                        <p>{messageDisplay}</p>
                    </div>
                </div>
                <div className="row">
                    <div className={`${styles.cancelBtn} col-md-6 mb8`}>
                        <button
                            onClick={onCloseClick}
                            type="button"
                            className={`btn btn-default btn-sm text-uppercase btn-block`}
                            disabled={isSending}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className={`${styles.confirmBtn} col-md-6 mb8 `}>
                        <button
                            onClick={(ev) => {
                                if (isSuccess || isError) {
                                    onCloseClick();
                                } else {
                                    onCtaClick(ev, confirmationDataValue);
                                }
                            }}
                            type="button"
                            className={`btn btn-primary btn-sm text-uppercase btn-block`}
                            disabled={isSending}
                        >
                            {isSending ? <span><i className="fas fa-circle-notch fa-spin" />&nbsp;Processing...</span> : confirmLabelDisplay}
                        </button>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

AwaitApiSuccessPopup.propTypes = {
    onCloseClick: PropTypes.func.isRequired,
    onCtaClick: PropTypes.func.isRequired,
    confirmationTitle: PropTypes.string,
    confirmationMessage: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    confirmationDataValue: PropTypes.any,
    confirmButtonLabel: PropTypes.string,
    successMessage: PropTypes.string,
    isSending: PropTypes.bool,
    isSuccess: PropTypes.bool,
    isError: PropTypes.bool,
};

AwaitApiSuccessPopup.defaultProps = {
    confirmationTitle: 'Confirmation',
    confirmationMessage: 'Are you sure?',
    confirmButtonLabel: 'Yes',
    successMessage: 'Your request processed successfully.',
    confirmationDataValue: null,
    isSending: false,
    isSuccess: null,
    isError: null,
};

export default AwaitApiSuccessPopup;
